import { DateUtils } from '@atlassian/mpac-utils';
export const transposeVersions = versions => {
  var _versions$edges;
  const versionNodes = (_versions$edges = versions.edges) === null || _versions$edges === void 0 ? void 0 : _versions$edges.map(edge => edge === null || edge === void 0 ? void 0 : edge.node).filter(Boolean);
  if (!versionNodes || versionNodes.length === 0) {
    throw new Error('No versions found');
  }
  return {
    __typename: 'MarketplaceVersionHistoryVersions',
    edges: versionNodes.map(node => ({
      __typename: 'MarketplaceVersionHistoryVersionEdge',
      node: {
        __typename: 'MarketplaceVersionHistoryVersion',
        // TODO: Figure why this is an array?
        id: node.version,
        compatibility: getCompatibility(node.deployment.compatibleProducts[0]),
        releaseDate: DateUtils.ISOFormatHyphenatedDate(node.releaseDate),
        releaseSummary: node.releaseSummary,
        version: node.version
      }
    })),
    pageInfo: versions.pageInfo,
    totalCount: versions.totalCount
  };
};
const getCompatibility = compatibleProduct => {
  switch (compatibleProduct.__typename) {
    case 'CompatibleAtlassianServerProduct':
    case 'CompatibleAtlassianDataCenterProduct':
      {
        var _compatibleProduct$at;
        // TODO: When can the product name not exist?
        const product = (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.name;
        const hosting = compatibleProduct.__typename === 'CompatibleAtlassianDataCenterProduct' ? 'Data Center' : 'Server';
        const minVersion = compatibleProduct.minimumVersion;
        const maxVersion = compatibleProduct.maximumVersion;
        return "".concat(product, " ").concat(hosting, " ").concat(minVersion, " - ").concat(maxVersion);
      }
    default:
      throw new Error('Versions page is only for server & data center products');
  }
};